import { zergApi } from "@/service/zerg";

const prefix = "/rrhh/adelanto-sueldo/motivos";

class MotivoAdelantoSueldoService {
    async index(params) {
        try {
            const data = await zergApi.post(`${prefix}/index`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async store(params) {
        try {
            const data = await zergApi.post(`${prefix}/store`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async show(params) {
        try {
            const data = await zergApi.post(`${prefix}/show`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async update(params) {
        try {
            const data = await zergApi.post(`${prefix}/update`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }
}

export default new MotivoAdelantoSueldoService();